'use client';

import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from 'next-themes';
import NextTopLoader from 'nextjs-toploader';
import { QueryProvider } from './query-provider';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <TooltipProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          forcedTheme="light"
          enableSystem={false}
          disableTransitionOnChange
        >
          <NextTopLoader
            easing="ease"
            showSpinner={false}
            color="hsl(var(--accent))"
          />
          {children}
          <Toaster position="top-center" />
        </ThemeProvider>
      </TooltipProvider>
    </QueryProvider>
  );
}
